import React from 'react'
import LayoutHeader from '../../../../layout/LayoutHeader'
import { PLAYLIST_PLATFORMS } from '../../../../constants/constants'
import { useNavigate } from 'react-router';
import SelectionCard from '../../../../components/SelectionCard';
import Spotify from '../../../../svg/MusicPlatform/Spotify';
import AppleMusic from '../../../../svg/MusicPlatform/AppleMusic';

export default function PlaylistPlatform() {
    const navigate = useNavigate();
    
    // Platform-specific icons mapping
    const platformIcons = {
        spotify: <Spotify />,
        apple_music: <AppleMusic />,
    };
    
    // Custom handler for platform selection
    const handlePlatformSelect = (value, txt) => {
        navigate('/add-section/add-playlist-link', { 
            state: { iconKey: value, name: txt } 
        });
    };
    
    return (
        <LayoutHeader>
            <div className="w-[350px] sm:w-[390px] flex flex-col justify-start items-center relative z-[0]">
                <div className='px-4 my-[50px] flex w-full justify-between'>
                    <p className='text-white'>Select a platform</p>
                    <p onClick={() => navigate('/add-section')} className='text-white cursor-pointer'>Go back</p>
                </div>
                <div className="w-full px-4">
                    {
                        PLAYLIST_PLATFORMS.map((item, index) => (
                            <div 
                                key={index} 
                                onClick={() => handlePlatformSelect(item.value, item.label)}
                                className="cursor-pointer"
                            >
                                <SelectionCard
                                    txt={
                                        <div className="flex items-center gap-x-[16px]">
                                            {platformIcons[item.value]}
                                            <span>{item.label}</span>
                                        </div>
                                    }
                                    // Pass # as link to prevent default Link behavior
                                    // since we're handling navigation via onClick
                                    link="#"
                                />
                            </div>
                        ))
                    }
                </div>
            </div>
        </LayoutHeader>
    )
}
